<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      class="insurance-icon spinning"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
  >
    <!-- Shield Background -->
    <path d="M32 2L12 10v18c0 12 8 24 20 30 12-6 20-18 20-30V10L32 2z" fill="currentColor" stroke="none"/>

    <!-- Shield Outline -->
    <path d="M32 2L12 10v18c0 12 8 24 20 30 12-6 20-18 20-30V10L32 2z" />

    <!-- Checkmark -->
    <path d="M22 32l6 6 14-14" />
  </svg>
</template>

<style scoped>
.insurance-icon {
  width: 50px;
  height: 50px;
  color: #ff9800;
}

.spinning {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
